// extracted by mini-css-extract-plugin
export default {"container":"Input_container__zGms-","label":"Input_label__eGp7A","input":"Input_input__70SE0","error":"Input_error__xWLuF","highlighted":"Input_highlighted__wdcC9"};